import {
  getApiActionTypes,
  getApiActionTypesValues,
} from 'store/redux/redux_utils';

const FETCH_LEASE_DURATION = 'FETCH_LEASE_DURATION';
const UPDATE_LEASE_DURATION = 'UPDATE_LEASE_DURATION';

const actions = {
  ...getApiActionTypes(FETCH_LEASE_DURATION),
};

// eslint-disable-next-line
const updateLeaseDuration = (leaseId: any, body: any) => ({
  promise: ({ client }: { client: any }) =>
    client.put(`/residents/extend-lease/${leaseId}`, body),
  types: getApiActionTypesValues(UPDATE_LEASE_DURATION),
});

export const LEASE_SIGNING_FLOW_DURATION_REDUCER = 'duration';

const initialState = {
  duration: {},
};

const reducer = (state = initialState, action: any = {}) => {
  switch (action.type) {
    case actions[`${FETCH_LEASE_DURATION}_SUCCESS`]:
      return {
        ...state,
        duration: {
          ...action.result,
        },
      };
    default:
      return state;
  }
};

export default reducer;
